import { useTaxResidencesEditionProps } from '../hooks/useTaxResidencesEditionProps';

import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';

import { IUser } from '@/features/user/store/user.model';

import { featuresSlugs } from '@/features/roles/store/models/features.model';

interface ITaxResidenceDetails {
  user: IUser;
  isSectionEditable: boolean;
  toogleSectionEditMode: () => void;
}

export function TaxResidencesEdition({ user, isSectionEditable, toogleSectionEditMode }: ITaxResidenceDetails) {
  const { taxResidenceData, isLoading, isFormDisabled, handleUpdateTaxResidences, onCancelEdition } =
    useTaxResidencesEditionProps(user);

  return (
    <KycInformationSection
      section={taxResidenceData}
      isOnEdition={true}
      sectionKey="tax-residences"
      isLoading={isLoading}
      isSectionNotEditable={isSectionEditable}
      isFormInvalid={isFormDisabled}
      featureSlug={featuresSlugs.EDIT_TAX_RESIDENCES}
      onEdit={() => toogleSectionEditMode()}
      onSave={() => handleUpdateTaxResidences(() => toogleSectionEditMode())}
      onCancel={() => onCancelEdition(() => toogleSectionEditMode())}
    />
  );
}
